import { Component, OnInit, ViewEncapsulation, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { LoginService } from '../login.service';
import { FlashMessagesService } from 'angular2-flash-messages';
import { Observable } from 'rxjs/Observable';
import { AutosuggestService } from '../autosuggest.service';

@Component({
  selector: 'app-add-service-offered',
  templateUrl: './add-service-offered.component.html',
  styleUrls: ['./add-service-offered.component.css']
})
export class AddServiceOfferedComponent implements OnInit {

  @ViewChild('fileInput') fileInput;

  model: any = {};
  user: any = {};
  results: any = {};
  currentUser: any = {};
  currentOrg: any;
  sessionData: any = {};
  searching = false;
  searchFailed = false;
  hideSearchingWhenUnsubscribed = new Observable(() => () => this.searching = false);
  certList: any = [];
  certificate: any = {
    cert_details: []
  };
  cert: any = {};
  contId: number;
  mask: any[] = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  tinmask: any[] = [/[0-9]/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
  certmask: any[] = [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
  userType: number;
  showLoader: boolean;
  wbe_goal: number;
  mbe_goal: number;
  savecertList: any;
  fieldName: string;
  fileList: FileList;
  certId: any;
  fileU: boolean;
  formedata: FormData;
  onlyview: boolean = false;
  headerLabel: string;
  getservicecategories: any;
  getservicelists: any;
  list: any;
  loaded: boolean;
  constructor(
    private router: Router,
    private loginservice: LoginService,
    private Autosuggest: AutosuggestService,
    private _arout: ActivatedRoute,
    private _flashMessagesService: FlashMessagesService

  ) { }
  ngOnInit(): void {
    this.loaded = false;
    this.currentUser = JSON.parse(this.loginservice.getLocalSession('currentUser'));
    this.loginservice.getservicecategory('', '1', this.currentUser).subscribe(data => {
      this.getservicecategories = data['comp_details'];
      this.loginservice.getserviceList('', this.currentUser).subscribe(data => {
        this.getservicelists = data['comp_details'];
        this._arout.params.subscribe(p => {
          if (p.view_id) {
            this.onlyview = true;
          }
          if (p.service_offered_id) {
            this.headerLabel = 'Edit';
            setTimeout(() => { this.getserviceoffered(p.service_offered_id); }, 300);
          } else {
            this.headerLabel = 'New';
            // this.getserviceoffered('');
          }
        }, error => { alert('Network Error params API'); });
      }, error => { alert('Network Error getserviceList API'); });
    }, error => { alert('Network Error getservicecategory API'); });

    this.model = {
      service_category_id: ''
    };
  }

  assign_checkbox(data) {
    data.forEach((obj) => {
      this.getservicelists.forEach((item) => {
        if (item['service_list_id'] === obj['service_list_id']) {
          item.checked = true;
        }
      });
    });
  }


  getserviceoffered(service_offered_id) {
    this.loginservice.getserviceofferedsAddEdit(service_offered_id, '1', this.currentUser)
      .subscribe(
        data => {
          if (data['status'] == 'success') {
            if (service_offered_id) {
              // this.model['service_offered_id'] = data['0']['service_offered_id'];
              this.model['service_category_id'] = data['data']['0']['service_category_id'];
              this.assign_checkbox(data['data']);
              this.loaded = true;
            }
            this.showLoader = false;
          } else {
            this.loaded = true;
            // this.model = [];
            // this._flashMessagesService.show('No Vendors!', { cssClass: 'alert-danger' });
            // this.router.navigate(['addlowertier']);
            this.showLoader = false;
          }
        },
        error => {
          this.loaded = false;
          alert('Network Error getserviceofferedsAddEdit API');
          this.showLoader = false;
        });
  }
  setCat(n) {
    if (n > 0) {
      this.model.service_category_id = n;
    } else {
      this.model.service_category_id = '';
    }
    setTimeout(() => { this.getserviceoffered(n); }, 300);

  }


  saveiserviceoffered() {
    const checkedItems = this.getservicelists.filter(item => item.checked);

    if (checkedItems.length > 0) {
      this.showLoader = true;
      this.model['type'] = 1;
      this.loginservice.saveiserviceoffered(this.model, checkedItems, this.currentUser)
        .subscribe(
          data => {
            if (data['status'] === 'success') {
              this._flashMessagesService.show('Updated Successfully', { cssClass: 'alert-success' });
              this.showLoader = false;
              this.router.navigate(['/Serviceoffered']);
            } else {
              this._flashMessagesService.show(data['message'], { cssClass: 'alert-danger' });
              this.showLoader = false;
            }
          },
          error => {
            alert('Network Error saveiserviceoffered API');
          });
    }
  }


}



// WEBPACK FOOTER //
// ./src/app/add-service-offered/add-service-offered.component.ts